import React, { useContext, useEffect, useState } from 'react'
import CIcon from '@coreui/icons-react'
import { cilPencil } from '@coreui/icons'
import moment from 'moment'
import SearchTable from 'src/components/searchTable'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faAngleDoubleDown } from '@fortawesome/free-solid-svg-icons'
import { AppContext } from 'src/views/context/app'
import { LEAD_API, LEAD_UPDATE_API } from 'src/views/utils/urls'
import useAxios from 'axios-hooks'
import ManageLead from './manageLead'
import { raiseToast } from '../../utils/helper'

const ManageLeads = () => {
  const { setLoader } = useContext(AppContext)
  const [leadList, setLeadList] = useState([])
  const [selectedLead, setSelectedLead] = useState({})
  const [openManageLeadModal, setOpenManageLeadModal] = useState(false)

  const [{ data: leadData, loading: leadDataLoading }, leadDataCall] = useAxios(
    {
      url: LEAD_API,
      method: 'get',
    },
    { manual: true },
  )

  const [{ data: updateLeadData, loading: updateLeadDataLoading }, updateLeadDataCall] = useAxios(
    {
      url: LEAD_UPDATE_API,
      method: 'put',
    },
    { manual: true },
  )

  useEffect(() => {
    leadDataCall()
  }, [])

  useEffect(() => {
    if (leadData && leadData.success) {
      setLeadList(leadData.data)
    }
  }, [leadData])

  useEffect(() => {
    if (updateLeadData && updateLeadData.success) {
      raiseToast('success', 'Lead updated successfully')
      leadDataCall()
      setOpenManageLeadModal(false)
    }
  }, [updateLeadData])

  useEffect(() => {
    setLoader(leadDataLoading || updateLeadDataLoading)
  }, [leadDataLoading, updateLeadDataLoading])

  const handleEditCall = (lead_id, payload) => {
    updateLeadDataCall({
      data: payload,
      url: LEAD_UPDATE_API + '?lead_id=' + lead_id,
    })
  }
  const handleEdit = (info) => {
    setSelectedLead(info)
    setOpenManageLeadModal(true)
  }

  const handleAdd = () => {
    setSelectedLead({})
    setOpenManageLeadModal(true)
  }

  const tableConfig = [
    {
      header: 'Name',
      dataCell: (info) => info.name,
      width: 20,
    },
    {
      header: 'Email',
      dataCell: (info) => info.email,
      width: 20,
    },
    {
      header: 'IP Address',
      dataCell: (info) => info.ip,
      width: 20,
    },
    {
      header: 'Created On',
      dataCell: (info) => moment.utc(info.created_date).format('DD-MM-YYYY'),
      width: 15,
    },
    {
      header: 'Lead Stage',
      dataCell: (info) => info?.lead_stage,
      width: 15,
    },
    {
      header: 'Query Type',
      dataCell: (info) => info?.query_type,
      width: 15,
    },
    {
      header: <FontAwesomeIcon icon={faAngleDoubleDown} size="lg" className="mx-1" />,
      dataCell: (info) => (
        <CIcon
          icon={cilPencil}
          style={{ cursor: 'pointer' }}
          size="lg"
          title="Edit"
          onClick={() => handleEdit(info)}
        />
      ),
      width: 5,
    },
  ]

  const handleCancel = () => {
    setOpenManageLeadModal(false)
    setSelectedLead({})
  }

  return (
    <>
      <h4>{`Manage Leads`}</h4>
      <SearchTable
        type={`Admin Account`}
        tableCardHeight={70}
        disableButton={true}
        buttonName={`+ Create New Lead`}
        buttonFunction={handleAdd}
        searchTerm={`email`}
        tableContent={leadList}
        tableConfig={tableConfig}
        createPermission={true}
      />
      {openManageLeadModal && (
        <ManageLead
          leadData={selectedLead}
          openModal={openManageLeadModal}
          onCancel={handleCancel}
          editCallback={handleEditCall}
          addCallback
        />
      )}
    </>
  )
}

export default ManageLeads
